import Section, { SectionRow } from 'components/Section/Section';
import Grid from 'components/Grid/Grid';
import TextField from 'components/Inputs/TextField/TextField';
import { Control, UseFormSetValue } from 'react-hook-form';
import SelectField from 'components/Inputs/SelectField/SelectField';
import BankSelect from 'components/Inputs/SelectField/Types/BankSelect/BankSelect/BankSelect';
import { account_type } from 'constants/account_type';
import { ContractDetailsFormData } from '../../ContractDetails';

type Props<T extends ContractDetailsFormData> = {
	control: Control<T>;
	disabled?: boolean;
	setValue: UseFormSetValue<T>;
};

const CashCollectionDepositoryAccount = <T extends ContractDetailsFormData>({
	control,
	disabled,
}: Props<T>): JSX.Element => {
	const name = 'product_cash_collection';
	return (
		<Section title="Cash Collection Depository Account">
			<SectionRow>
				<Grid column size={1} of={3}>
					<BankSelect
						required
						label="Bank Name"
						placeholder="Select Bank"
						name={`${name}.bank_id`}
						control={control}
						disabled={disabled}
					/>
				</Grid>
				<Grid column size={1} of={3}>
					<TextField
						required
						label="Bank Branch"
						placeholder="Bank Branch"
						name={`${name}.bank_branch`}
						control={control}
						disabled={disabled}
					/>
				</Grid>
			</SectionRow>
			<SectionRow>
				<Grid column size={1} of={3}>
					<TextField
						required
						label="Account Name"
						placeholder="Account Name"
						name={`${name}.account_name`}
						control={control}
						disabled={disabled}
					/>
				</Grid>
				<Grid column size={1} of={3}>
					<TextField
						required
						label="Account Number"
						placeholder="Account Number"
						name={`${name}.account_no`}
						control={control}
						disabled={disabled}
					/>
				</Grid>
				<Grid column size={1} of={3}>
					<SelectField
						required
						label="Account Type"
						placeholder="Select Account Type"
						name={`${name}.account_type`}
						control={control}
						disabled={disabled}
						options={account_type}
					/>
				</Grid>
			</SectionRow>
		</Section>
	);
};

export default CashCollectionDepositoryAccount;
